<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{title}}</h1>
      </v-flex>
    </v-layout>

    <div v-if="restrictionList !== null ? restrictionList.length > 0 : false">
      <v-layout row class="mx-3">
        <v-flex xs12>
          <template>
            <v-data-table
                :headers="headers"
                :items="restrictionList"
                hide-actions
                class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  <span class="cursor-pointer" @click="$router.push('/restrictions/single/' + props.item.id)">{{props.item.title}}</span>
                </td>
                <td class="text-xs-left">{{ $moment(props.item.start_date).format('DD.MM.YYYY') }}</td>
                <td class="text-xs-left">{{ $moment(props.item.end_date).format('DD.MM.YYYY') }}</td>
                <td class="text-xs-left">
                  <div v-if="mode === 'active'">
                    <v-btn
                        flat
                        icon
                        class="ma-1"
                        @click="editRestriction(props.item.id)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                        flat
                        icon
                        class="ma-1"
                        @click="deleteRestriction(props.item.id)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </div>
                </td>
              </template>
            </v-data-table>
          </template>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="mode === 'active' && restrictionList !== null ? restrictionList.length === 0 : false">
      <div class="ml-3 subheading">Нет активных ограничений. <span @click="$router.push('/restrictions/new')" class="cursor-pointer primary--text">Добавить новое</span></div>
    </div>

    <div v-if="mode === 'past' && restrictionList !== null ? restrictionList.length === 0 : false">
      <div class="ml-3 subheading">Нет архивных ограничений.</div>
    </div>

    <v-layout row v-if="pages > 1">
      <v-flex xs12>
        <div class="text-xs-left mt-3">
          <v-pagination
              v-model="page"
              :length="pages"
              :total-visible="7"
              @input="changePage()"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
        v-if="mode === 'active'"
    >
      <v-card>
        <v-card-title class="headline">Удалить ограничение?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deleteRestrictionConfirm(deleteRestrictionId)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deleteRestrictionCancel()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import HelpMixin from '../../mixins/help'

  export default {
    mixins: [HelpMixin],
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Ограничения'}
        ],
        headers: [
          {
            text: 'Название',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Дата начала',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Дата окончания',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Действия',
            align: 'left',
            sortable: false,
            value: 'name'
          }
        ],
        pageDataReady: {
          isReady: false,
          restrictionList: false
        },
        page: 1,
        mode: 'active',
        title: 'Активные ограничения',
        deleteDialog: false,
        deleteRestrictionId: null
      }
    },
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.restrictionList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      changePage () {
        this.scrollUp()

        this.pageDataReady = {
          isReady: false,
          restrictionList: false
        }
        this.$store.commit('setPageLoading', true)

        if (this.mode === 'active') {
          this.$router.push('/restrictions/active/' + this.page)
        } else if (this.mode === 'past') {
          this.$router.push('/restrictions/past/' + this.page)
        } else {
          this.$store.dispatch('getRestrictionList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
        }
      },
      editRestriction (id) {
        this.$router.push('/restrictions/edit/' + id)
      },
      deleteRestriction (id) {
        this.deleteDialog = true
        this.deleteRestrictionId = id
      },
      deleteRestrictionCancel () {
        this.deleteDialog = false
        this.deleteRestrictionId = null
      },
      deleteRestrictionConfirm () {
        this.deleteDialog = false
        this.$store.dispatch('deleteRestriction', {id: this.deleteRestrictionId})
        this.deleteRestrictionId = null
        this.$store.dispatch('getRestrictionList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
      },
      onCreated () {
        if (typeof this.$route.params.page !== 'undefined') {
          this.page = parseInt(this.$route.params.page)
        } else {
          this.page = 1
        }
        if (~this.$router.currentRoute.path.indexOf('/restrictions/active')) {
          this.mode = 'active'
          this.title = 'Активные ограничения'
        } else if (~this.$router.currentRoute.path.indexOf('/restrictions/past')) {
          this.mode = 'past'
          this.title = 'Архив ограничений'
        }
        this.$store.commit('setPageLoading', true)
        this.$store.commit('setPageTitle', this.title)

        this.$store.dispatch('getRestrictionList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
          .then(() => {
            this.pageDataReady.restrictionList = true
            this.pageDataStatus()
          })
      }
    },
    computed: {
      restrictionList () {
        return this.$store.getters.restrictionList
      },
      totalCount () {
        return this.$store.getters.restrictionTotalCount
      },
      pages () {
        let pages = this.totalCount / 10
        if ((pages ^ 0) !== pages) {
          pages = Math.floor(pages) + 1
        }
        return pages
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Restrictions/RestrictionList.vue